// extracted by mini-css-extract-plugin
export default {"container":"EmptyStateCampaign_container__EeX8K","content":"EmptyStateCampaign_content__6fbcq"};